import $ from 'jquery';
import namespace from '../namespace';
import OfcsObject from '../object';
import Modal from './modal';

/**
 * @class ModalStack
 */
class ModalStack extends OfcsObject {
    /** @var {Modal[]} */
    stack = [];

    /**
     * @private
     */
    _pauseModal() {
        if (window.currentModal) {
            window.currentModal.pause();
        }
    }

    /**
     * @param {Object} [parameters]
     * @private
     */
    _showCurrentModal(parameters) {
        if (window.currentModal) {
            const isPaused = window.currentModal.getPaused();

            if (isPaused) {
                window.currentModal.resume();
            } else {
                window.currentModal.show(parameters);
            }
        }
    }

    /**
     * Remove item from stack and display the previous one
     *
     * @private
     */
    _popModal() {
        this.stack.pop();

        window.currentModal = this.stack[this.stack.length - 1];

        if (window.currentModal) {
            this._showCurrentModal();
        }
    }

    /**
     * @private
     */
    _toggleBackdrop() {
        const backdrop = $('.modal-backdrop');
        const hasBackdrop = backdrop.get(0);

        if (this.stack.length === 0) {
            backdrop.remove();
        } else if (!hasBackdrop) {
            $('<div class="modal-backdrop"></div>').appendTo('body');
        }
    }

    /**
     * @param {Modal} modal
     * @private
     */
    _destroyModal(modal) {
        if (modal) {
            modal.hide();
        }
    }

    /**
     * Closes all modals and displays an error message
     *
     * @param {{ current: Modal, error: modal }} modals
     * @param {Object} errorMsg
     */
    closeAllModalsOnError(modals, errorMsg) {
        for (let i = 0; i < this.stack.length; i += 1) {
            this._destroyModal(this.stack[i]);
        }

        this.stack.splice(0, this.stack.length);

        if (modals?.current instanceof Modal) {
            if (modals.current.showError) {
                modals.current.showError(errorMsg);
            } else {
                this._destroyModal(modals.current);
                this.showModal(modals.error, errorMsg);
            }
        }
    }

    removeAllModals() {
        this.stack.forEach(modal => modal.modalContainer.hide().remove());
        this.stack.splice(0, this.stack.length);
        this._toggleBackdrop();
    }

    /**
     * Add modal to stack and display a new modal
     *
     * @param {Modal} modal
     * @param {Object} parameters
     */
    showModal(modal, parameters = {}) {
        if (!(modal instanceof Modal)) {
            throw new TypeError(`modal ${modal} is not an instance of Ofcs.Modal.Modal`);
        }

        this._pauseModal();

        this.stack.push(modal);
        window.currentModal = modal;

        this._toggleBackdrop();

        window.currentModal.once('hidden', () => this._onCurrentModalClosed());

        this._showCurrentModal(parameters);
    }

    _onCurrentModalClosed() {
        this._popModal();
        this._toggleBackdrop();
    }
}

namespace('Ofcs.Modal');
Ofcs.Modal.ModalStack = ModalStack;
export default ModalStack;
